import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import Pagination from "src/components/Pagination/Pagination";
import { path } from "src/constants/path";
import SubAccessControlPopup from "../../components/Popup/SubAccessControlPopup";
import SubAccessControlPanel from "../../components/ControlPanel/SubAccessControlPanel";
import SubAccessControlTable from "../../components/Table/SubAccessControlTable";
import {
  createAccessControl,
  getACDetail,
  getSubAccessControl,
  removeAccessControl,
  updateAccessControl,
} from "src/apis/System/accessControl.api";
import { NotifyConfirm } from "src/components/notify/Notify";
import { createPermissionCRUD } from "src/apis/System/permission.api";

const initAccessControlData = {
  list: [],
  total_record: 0,
};

export const AccessControlDetail = () => {
  const { id } = useParams();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const {
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();
  const [accessControlData, setAccessControlData] = useState(
    initAccessControlData
  );

  const [accessControlDetail, setAccessControlDetail] = useState([]);
  const [filterAccessControls, setFilterAccessControls] = useState([]);
  const [parentRoute, setParentRoute] = useState("");
  const [parentRouteId, setParentRouteId] = useState("");
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };
    getSubAccessControl(id, query, (result) => {
      setAccessControlData(result);
      setFilterAccessControls([...result.list]);
    });

    getACDetail(id, (result) => {
      setParentRoute(result.route);
      setParentRouteId(result.id);
      setAccessControlDetail(result);
    });
  }, [endDate, id, limit, numberPage, search, startDate, status]);

  //----------------

  const actionAfterCreateOrUpdate = (result, resetForm) => {
    if (result.data?.status === 422) {
      setErrorsForm({ ...result.data.data });
    } else {
      resetForm();
      window.location.reload(true);
    }
  };

  const addOrEdit = (accessControl, resetForm) => {
    if (!accessControl.id) {
      const infoCreatePermission = {
        routeName: accessControl.childRoute,
        permissionAction: accessControl.permissionAction,
        name: accessControl.name,
      };

      createPermissionCRUD(infoCreatePermission, (result) => {
        accessControl = {
          ...accessControl,
          permissionIds: result,
        };
        createAccessControl(
          { ...accessControl, route: accessControl.childRoute },
          (result) => {
            actionAfterCreateOrUpdate(result, resetForm);
          }
        );
      });
    } else {
      const body = {
        permissionAction: accessControl.permissionAction,
        name: accessControl.name,
        route: accessControl.childRoute,
      };
      updateAccessControl(accessControl.id, body, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    }
  };

  const handleOpenPopup = (item, parentRoute, parentRouteId) => {
    setOpenPopup(true);
    setRecordForEdit(item);
    setParentRoute(parentRoute);
    setParentRouteId(parentRouteId);
    setErrorsForm({});
  };

  const handleDelete = (id) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        // * tìm vị trí của trong list
        const foundAccessControl = accessControlData.list.findIndex(
          (accessControl) => accessControl.id === id
        );

        if (foundAccessControl !== -1) {
          removeAccessControl(id, (_) => {
            window.location.reload(true);
          });
        }
      }
    });
  };

  return (
    <div>
      <div className="page-header">
        <h2>{`${accessControlDetail.name} -> SubRoute`}</h2>
      </div>

      <SubAccessControlPopup
        recordForEdit={recordForEdit}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        addOrEdit={addOrEdit}
        parentRoute={parentRoute}
        parentRouteId={parentRouteId}
        errorsForm={errorsForm}
      />

      <SubAccessControlPanel
        permissionsAccessControl={permissionsAccessControl}
        handleOpenPopup={handleOpenPopup}
        parentRoute={parentRoute}
        parentRouteId={parentRouteId}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </SubAccessControlPanel>

      <SubAccessControlTable
        data={filterAccessControls}
        handleOpenPopup={handleOpenPopup}
        handleDelete={handleDelete}
        status="active"
      />

      <Pagination
        pathname={`${path.systemAccessControl}`}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={accessControlData.total_record}
      />
    </div>
  );
};
